import { ModalAnnulationConfirmationComponent } from './../../../../shared/components/modals/modal-annulation-confirmation/modal-annulation-confirmation.component';
import { SimpleQueryResponse } from './../../../../shared/dtos/simpleQueryResponse';
import { FilterBcDTO } from './../../../../shared/dtos/filterBcDTO';
import { NTHFlag } from '../../../../shared/constants/flag';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Router } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { ModalUpdateConfirmationComponent } from 'src/app/shared/components/modals/modal-update-confirmation/modal-update-confirmation.component';
import { TrieTabService } from 'src/app/shared/services/utilities/trie-tab.service';
import { BcModel } from 'src/app/shared/models/societe-linked/bc/bc.model';
import { UserService } from 'src/app/shared/services/user.service';
import { UtilisateurModel } from 'src/app/shared/models/utilisateur/utilisateur.model';
import { AddCommentModalComponent } from 'src/app/shared/components/modals/add-comment/add-comment-modal.component';
import { BcValidationModel } from 'src/app/shared/dtos/bcValidationModel';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, interval, Observable, Subject, Subscription } from 'rxjs';
import { throttle } from 'rxjs/operators';
import { BcService } from 'src/app/shared/services/bc/bc.service';
registerLocaleData(localeFr, 'fr');
import { SessionService } from 'src/app/shared/services/session.service';
import { UserModelDTO } from 'src/app/shared/dtos/userModelDTO';
import { DefinitionNamesBC, DefinitionTypeBC } from 'src/app/shared/typeBCDefinitions';

@Component({
  selector: 'app-bc-list',
  templateUrl: './bc-list.component.html',
  styleUrls: ['./bc-list.component.scss']
})

export class BcListComponent implements OnInit, OnChanges {
  // tslint:disable-next-line: max-line-length
  displayedColumnsBC: string[] = ['selectRow', 'typeBC', 'societe', 'libelleCa1', 'libelle', 'status', 'code', 'dBc', 'libelleFourn', 'ht', 'dLivraison', 'annule', 'valide', 'livre', 'provis', 'dProvis', 'bloque','bp', 'trigrammeCreateur', 'chantier', 'BCAmont'];
  // tslint:disable-next-line
  @Input() ifCreateBp: boolean = false;
  @Input() ifListAValide: boolean = false;
  @Input() filtreData: FilterBcDTO;
  @Input() simpleQueryBcResponse: SimpleQueryResponse<BcModel> = null;
  matDataSourceBC: MatTableDataSource<BcModel> = new MatTableDataSource<BcModel>();
  @Output() selectedRowsEmit = new EventEmitter<BcModel[]>();
  selectedBcs: BcModel[] = [];
  selection = new SelectionModel<BcModel>(true, []);
  length: number;
  pageIndex: number;
  pageSize = 25;
  sortState: Sort = { active: 'dBc', direction: 'asc' };
  dataSource: any[];
  users: UtilisateurModel[] = [];
  user: UtilisateurModel;
  public FlagEnum = NTHFlag;
  public width = 0;
  private resObservable = new Subject<boolean>();

  definitionNamesBC = DefinitionNamesBC; //pour son html
  definitionTypeBC = DefinitionTypeBC; //pour son html


  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  @Input() datasource: BcModel[];


  private paginationSubcription: Subscription;

  private paginationBc = new Subject<FilterBcDTO>();
  public pagination = this.paginationBc.asObservable();


  constructor(
    private triTabService: TrieTabService,
    public dialog: MatDialog,
    private router: Router,
    private toastr: ToastrService,
    private bcService: BcService,
    private userService: UserService,
    private sessionService: SessionService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // tslint:disable-next-line: max-line-length
    if (changes.datasource && changes.datasource.currentValue && changes.simpleQueryBcResponse && changes.simpleQueryBcResponse.currentValue) {
      this.dataSource = changes.datasource.currentValue.slice();
      this.matDataSourceBC = new MatTableDataSource(this.dataSource);
      this.length = this.simpleQueryBcResponse.count;
      this.pageIndex = this.simpleQueryBcResponse.pageNumber;
      this.pageSize = this.simpleQueryBcResponse.pageSize;
    }
    if (this.ifCreateBp || this.ifListAValide) {
      // tslint:disable-next-line: max-line-length
      this.displayedColumnsBC = ['selectRow', 'typeBC', 'societe', 'libelleCa1', 'libelle', 'status', 'code', 'dBc', 'libelleFourn', 'ht', 'dLivraison', 'annule', 'valide', 'livre', 'provis', 'dProvis', 'bloque', 'bp', 'trigrammeCreateur', 'chantier', 'BCAmont'];
    } else {
      this.displayedColumnsBC = ['typeBC', 'societe', 'libelleCa1', 'libelle', 'status', 'code', 'dBc', 'libelleFourn', 'ht', 'dLivraison', 'annule', 'valide', 'livre', 'provis', 'dProvis', 'bloque', 'bp', 'trigrammeCreateur', 'chantier', 'BCAmont'];
    }
  }

  ngOnInit(): void {
    this.loadUsers();
    this.sessionService.currentUser.subscribe(user => {
      this.user = user;
    });
    this.width = window.innerWidth; 
    this.paginationSubcription = this.paginationBc.pipe(throttle(() => this.resObservable)).subscribe(result => { 
      this.bcService.getFiltredBc(this.filtreData).subscribe(data => {
        this.resObservable.next(true);
        this.simpleQueryBcResponse = data;
        this.datasource = data.objets;
        this.length = this.simpleQueryBcResponse.count;
        // tslint:disable-next-line: max-line-length
        const datas = this.datasource.slice();
        this.matDataSourceBC = new MatTableDataSource(datas.slice(0, this.pageSize));
        this.matDataSourceBC.data.forEach(row => {
          // Lors du chargement des pages reselectionner les lignes 
          if (this.selectedBcs.find(line => line.id === row.id)) {
            this.selection.select(row);
          }
        })
      }, (error) => this.resObservable.next(false));
    });
  }

  private loadUsers(): void {
    this.userService.getAll().subscribe((users) => {
      this.users = users;
    });
  }

  getAssociatedUser(bc: BcModel): string {
    const usr = this.users.find(x => x.id === bc.idCreateur);
    let str = '';
    if (usr) {
      str = usr.prenom + ' ' + usr.nom;
    }
    return str;
  }
  getAssociatedUserTriGram(bc: BcModel): string {
    const usr = this.users.find(x => x.id === bc.idCreateur);
    let str = '';
    if (usr) {
      str = usr.prenom.substring(0, 1).toUpperCase() + usr.nom.substring(0, 2).toUpperCase();
    }
    return str;
  }

  changePage(event?: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.filtreData.pageNumber = event.pageIndex;
    this.filtreData.pageSize = event.pageSize;
    this.loadPage();
  }

  trieTab(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.filtreData.descending = false;
    } else {
      this.filtreData.descending = true;
    }
    this.sortState = sort;
    this.filtreData.order = sort.active;
    this.loadPage();
  }

  loadPage(): void {
      this.paginationBc.next(this.filtreData);
  }

  editBC(bc: BcModel): void {
    if (this.ifCreateBp) { return; }
    const dialogRef = this.dialog.open(ModalUpdateConfirmationComponent, {
      data: {
        type: 'BC',
        bcType: bc.type,
        statut: bc.status,
        message: 'Que souhaitez-vous réaliser sur ce bon de commande ?',
        icone: 'warning_amber',
        icon_color: 'warn',
        color: 'accent',
        idSociete: bc.idSociete,
        codeCa1: bc.codeCa1,
        nivStatus: bc.statusNum,
        fAnnule: bc.fAnnule,
        fDeprovis: bc.fDeprovis,
        fLivre: bc.fLivre,
        fHasBp: bc.fHasBp,
        bBloquer: bc.bBloque,
        fValide : bc.fValide,
        user: this.user,
        bcSocieteId: bc.idSociete,
        bcCreateurId: bc.idCreateur,
        bcCode: bc.code,
        bcLibelle: bc.libelle
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        switch (res) {
          case 'Livrer': {
            this.router.navigate(['edit-bc/' + bc.id]);
            break;
          }
          case 'Modifier Brouillon': {
            if(bc.type === DefinitionTypeBC.BCEnveloppe){
              this.router.navigate(['brouillon-enveloppe-bc/' + bc.id]);
            }else{
              this.router.navigate(['brouillon-bc/' + bc.id]);
            }
            break;
          }
          case 'Voir': {
            this.router.navigate(['read-bc/' + bc.id]);
            break;
          }
          case 'Valider': {
            this.router.navigate(['validate-bc/' + bc.id]);
            break;
          }
          case 'Créer BP': {
            this.router.navigate(['create-bp/']);
            break;
          }
          case 'Dupliquer': {
            const obj = Object.assign({}, bc);
            this.bcService.duplicate(obj).subscribe(value => {
              this.router.navigate(['brouillon-bc/' + value.id]);
            });
            break;
          }
          case 'Compléter le BC': { //remplace 'BC de régularisation'
            const obj = Object.assign({}, bc);
            this.bcService.regularisationBc(obj).subscribe(value => {
              this.router.navigate(['brouillon-bc/' + value.id]);
            });
            break;
          }
          case 'Annuler et refaire le BC': {
            const obj = Object.assign({}, bc);
            this.bcService.refaireBc(obj).subscribe(value => {
              if (value && value.id) {
                this.router.navigate(['brouillon-bc/' + value.id]);
                this.bcService.cancel(bc).subscribe((otherbc) =>
                {
                  this.datasource = this.datasource.filter(b => b.id !== otherbc.id);
                  if(otherbc.status !== "Brouillon")
                    this.datasource.push(otherbc);
  
                  // tslint:disable-next-line: max-line-length
                  const datas = this.datasource.slice();
                  this.matDataSourceBC = new MatTableDataSource(datas.slice(0, this.pageSize));
                  this.toastr.success('Annulation du bon de commande ' + (otherbc.fValide === 2 ? otherbc.code : "Cxxxxxxxxxx") +  ' réussie');
  
                });
              } else {
                this.toastr.error('Erreur dans l’annulation du bon de commande ' + (bc.fValide === 2 ? bc.code : "Cxxxxxxxxxx"));
              }
            });
            break;
          }
          case 'Bloquer': {
            this.openModalComment(bc, true);
            break;
          }
          case 'Débloquer': {
            this.openModalComment(bc, false);
            break;
          }
          case 'Annuler': {
            this.bcService.cancel(bc).subscribe((otherbc) =>
            {
              this.datasource = this.datasource.filter(b => b.id !== otherbc.id);
              if(otherbc.status !== "Brouillon")
                this.datasource.push(otherbc);

              // tslint:disable-next-line: max-line-length
              const datas = this.datasource.slice();
              this.matDataSourceBC = new MatTableDataSource(datas.slice(0, this.pageSize));
              this.toastr.success('Annulation du bon de commande ' + (otherbc.fValide === 2 ? otherbc.code : "Cxxxxxxxxxx") +  ' réussie');

            });
          }
        }
      }
    });
  }

  openModalComment(bc: BcModel, bloquer: boolean) {
    const dialogRef = this.dialog.open(AddCommentModalComponent, {
      data: {
        title: 'Commentaire du litige',
        color: 'primary',
        icon_color: 'accent',
        required: true
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res !== '' && res) {
        bc.bBloque = bloquer;
        const bcwithcomment = new BcValidationModel(bc);
        bcwithcomment.commentaire = res;
        this.bcService.debloquerBc(bcwithcomment).subscribe(value => {
          bc.fLitige = value.fLitige;
        });
      }else if (res === '') {
        this.toastr.error('Commentaire obligatoire');
      }
    });
  }

  compareRow(row: BcModel): boolean {
    if (row) {
      const currentBc = this.selectedBcs.find(line => line.position === row.position && line.id === row.id);
      if (currentBc && this.selectedBcs.length > 0) {
        for (const bc of this.selectedBcs) {
          if (bc) {
            if (bc.id === currentBc.id) {
              return true;
            } else {
              return false;
            }
          }
        }
      }
    }
  }

  reload(): void {
    this.matDataSourceBC = new MatTableDataSource<BcModel>(this.dataSource);
    this.matDataSourceBC.paginator = this.paginator;
    this.matDataSourceBC.data.forEach(row => this.selection.select(row));
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle(): void {

    if (this.isAllSelected()) {
      this.deleteBcRows();
      this.selection.clear();
    }
    else {
      if (this.ifCreateBp) {
        this.matDataSourceBC.data.forEach(row => {
          // Si on ne trouve pas dans la sélection la ligne, on l'ajoute.
          if (!this.selectedBcs.find(line => line === row) && !this.isRowDisabled(row)) {
            this.selection.select(row);
            this.setRowToBcs(row);
          }
        });
      } else {
        this.matDataSourceBC.data.forEach(row => {
          // Si on ne trouve pas dans la sélection la ligne, on l'ajoute.
          if (!this.selectedBcs.find(line => line === row)) {
            this.selection.select(row);
            this.setRowToBcs(row);
          }
        });
      }
    }
    this.selectedRowsEmit.emit(this.selectedBcs);
  }

  selectRow(row: BcModel): void {
    // On passe si la ligne est censée être désactivée
    if (this.ifCreateBp) {
      if (this.isRowDisabled(row)) {
        return;
      }
    }
    this.selection.toggle(row);
    let currentBc: BcModel;
    if (row) {
      currentBc = this.selectedBcs.find(model => model === row);
    }
    if (!currentBc) {
      this.setRowToBcs(row);
    } else {
      this.deleteBcRow(row);
    }
    this.selectedRowsEmit.emit(this.selectedBcs);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    if (numSelected === 0) {
      return false; // Si il n'y a pas de lignes sélectionnées, on retourne faux ici
    }
    // On compte le nombre de lignes qui ne sont pas désactivées, et on les compare au nb de lignes sélectionnées
    if (this.ifCreateBp) {
      let i = 0;
      for (const row of this.matDataSourceBC.data) {
        if (!this.isRowDisabled(row)) {
          i++;
        }
      }
      return numSelected === i;
    }
    return this.length === numSelected;
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: BcModel): string {
    if (!row) {
      return `${!this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  /* Remove all checked items in bcArray  */
  deleteBcRows(): void {
    this.selectedBcs = [];
  }

  /* Remove item in bcArray */
  deleteBcRow(row: BcModel): void {
    this.selectedBcs.splice(this.selectedBcs.findIndex(r => r === row), 1);
  }

  /* Add item into bcArray */
  setRowToBcs(row: BcModel): void {
    this.selectedBcs.push(row);
  }

  /**
   * Vérifie si une ligne est à desactiver ou non
   * @param row La ligne à tester
   * @returns vrai si la ligne doit être désactivée
   */
  isRowDisabled(row: BcModel): boolean {
    return !(this.selectedBcs.length === 0 || this.selectedBcs.find(r => r.codeFourn === row.codeFourn && r.codeCa1 === row.codeCa1));
  }


  ngOnDestroy(): void {
    this.paginationSubcription.unsubscribe();
  }
}
